var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.6011L6.3983 21.5L11.8932 17.4138C12.0855 17.2708 12.2382 17.101 12.3423 16.9142C12.4464 16.7273 12.5 16.5271 12.5 16.3248V6.67269C12.5 6.47039 12.4464 6.27017 12.3423 6.0833C12.2382 5.89645 12.0855 5.72668 11.8932 5.58368L6.40169 1.5L2.50339 4.39891L10.5864 10.4098C10.7789 10.5529 10.9315 10.7228 11.0356 10.9098C11.1397 11.0968 11.1932 11.2972 11.193 11.4996C11.1929 11.702 11.139 11.9024 11.0347 12.0893C10.9303 12.2762 10.7775 12.446 10.5848 12.589L2.5 18.6011Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenIcon);
export default __webpack_public_path__ + "static/media/token_icon.94bd0ea6903685f838588c327e304f5b.svg";
export { ForwardRef as ReactComponent };